import { motion } from 'framer-motion';
import { Building, Mail, MapPin, Phone } from 'lucide-react';

export default function ContactInfo() {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <h2 className="text-2xl font-bold text-gray-900 mb-8">Get in Touch</h2>
      <div className="space-y-6">
        <div className="flex items-start gap-4">
          <Building className="w-6 h-6 text-brown-600 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-semibold">Office</h3>
            <p className="text-gray-600">BNC Africa Holdings Group Limited</p>
          </div>
        </div>
        
        <div className="flex items-start gap-4">
          <MapPin className="w-6 h-6 text-brown-600 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-semibold">Address</h3>
            <p className="text-gray-600">Accra, Ghana</p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <Phone className="w-6 h-6 text-brown-600 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-semibold">Phone</h3>
            <div className="text-gray-600">
              <p>024 314 9817</p>
              <p>024 306 5135</p>
            </div>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <Mail className="w-6 h-6 text-brown-600 flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-semibold">Email</h3>
            <p className="text-gray-600">info@bncafricaholdings.com</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}